

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DesignationParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Designation {
    id?: string;
    name: string;
    tenantId?: string;
    brandId?: string;
    isActive?:Boolean;
    
    parameters?: DesignationParameter[];
    links?: any;
}

export abstract class DesignationtData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Designation[]>;
  abstract create(url: string,data: Designation): Observable<any>;
  abstract update(url: string,data: Designation): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
